import * as React from 'react';
import { TitleWithIcon } from '../../../../components/TitleWithIcon/TitleWithIcon.js';
import { LocationInfo } from '../../../../modules/LocationInfo/layout/LocationInfo.js';

const PickupLocationInformation = ({ title , location , onPickupModalShow , hideTitle =false  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, !hideTitle && /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "store",
        label: title
    }), /*#__PURE__*/ React.createElement(LocationInfo, {
        location: location,
        onEdit: onPickupModalShow
    }))
;

export { PickupLocationInformation };
//# sourceMappingURL=PickupLocationInformation.js.map
